import { type ChangeEvent } from 'react'
import { addToArray } from '../../../../../../shared/utils/arrayUtils'
import { normalizers } from './normalizers'
import { proxyRefund } from './refundProxy'
import { type FormFieldNamesEnum } from './formFieldNamesEnum'
import { validators } from './validators'

export const handleChange = (fieldName: FormFieldNamesEnum) => (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  processChange(e.target.value, fieldName)
}

export const processChange = (val: string, fieldName: FormFieldNamesEnum): void => {
  const normalizer = normalizers[fieldName]
  const normalized = normalizer ? normalizer(val) : val
  proxyRefund.formValues[fieldName] = normalized
  proxyRefund.formDirtied = addToArray(proxyRefund.formDirtied, fieldName)
  const validator = validators[fieldName]
  if (validator) { proxyRefund.formErrors[fieldName] = validator(normalized) }
}

export const handleBlur = (fieldName: FormFieldNamesEnum) => () => {
  proxyRefund.formBlurred = addToArray(proxyRefund.formBlurred, fieldName)
}
